'use client'

import { createContext, useContext, type ReactNode } from 'react'
import type { ReportingDatePresetId } from '@/lib/dashboard/reportingDatePresets'

export type DashboardDateContextValue = {
  dateFrom: string
  dateTo: string
  setDateFrom: (v: string) => void
  setDateTo: (v: string) => void
  applyReportingPreset: (preset: ReportingDatePresetId) => void
  reloadDashboard: () => void
  dashboardLoading: boolean
  shopDisplayTz: string
}

const DashboardDateContext = createContext<DashboardDateContextValue | null>(null)

export function DashboardDateProvider({
  value,
  children,
}: {
  value: DashboardDateContextValue
  children: ReactNode
}) {
  return <DashboardDateContext.Provider value={value}>{children}</DashboardDateContext.Provider>
}

export function useDashboardDate(): DashboardDateContextValue {
  const v = useContext(DashboardDateContext)
  if (!v) {
    throw new Error('useDashboardDate must be used within DashboardDateProvider')
  }
  return v
}

/** Safe for components that may render outside the dashboard shell. */
export function useDashboardDateOptional(): DashboardDateContextValue | null {
  return useContext(DashboardDateContext)
}
